import { PushHistoryToolbar } from './PushHistoryToolbar';
import { fixtureProps } from './fixtures';
const meta = {
    title: 'Features/Settings/Technicians/PushHistory/PushHistoryToolbar',
    component: PushHistoryToolbar,
    parameters: { layout: 'padded' },
    args: { rows: fixtureProps.rows, filter: 'all', tinted: true, platformUnavailable: false }
};
export default meta;
export const AllRows = {};
export const LinkedOnly = { args: { filter: 'both' } };
export const PlatformUnavailable = { args: { platformUnavailable: true } };
